import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "toggle", "container"];

  connect() {
    this.hidePanel();
    this.boundHandleEscape = this.handleEscape.bind(this);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEscape);
  }

  toggle(event) {
    event.preventDefault();
    this.isOpen ? this.close() : this.open();
  }

  open() {
    if (!this.hasPanelTarget) return;

    this.panelTarget.classList.remove("hidden", "opacity-0", "-translate-y-1");
    this.panelTarget.classList.add("opacity-100", "translate-y-0");
    this.toggleTarget.setAttribute("aria-expanded", "true");
    document.addEventListener("keydown", this.boundHandleEscape);
    this.isOpen = true;

    // Focus the first focusable element inside the panel for accessibility
    const focusable = this.panelTarget.querySelector(
      "button, [href], select, textarea, input, [tabindex]:not([tabindex='-1'])"
    );
    if (focusable) {
      focusable.focus({ preventScroll: true });
    }
  }

  close() {
    if (!this.hasPanelTarget) return;

    this.panelTarget.classList.remove("opacity-100", "translate-y-0");
    this.panelTarget.classList.add("opacity-0", "-translate-y-1");
    this.toggleTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("keydown", this.boundHandleEscape);
    this.isOpen = false;

    window.setTimeout(() => {
      if (!this.isOpen && this.hasPanelTarget) {
        this.panelTarget.classList.add("hidden");
      }
    }, 120);
  }

  windowClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  hidePanel() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("opacity-100", "translate-y-0");
      this.panelTarget.classList.add("hidden", "opacity-0", "-translate-y-1");
      this.toggleTarget.setAttribute("aria-expanded", "false");
    }
    this.isOpen = false;
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close();
      this.toggleTarget.focus({ preventScroll: true });
    }
  }
}
